<template>
  <div class="bg-neutral-primary rounded-md">
    <slot name="image" />

    <div class="text-center w-72" :class="wrapperClass">
      <NText
        weight="bold"
        variant="caption1"
        tag="p"
        class="px-8"
        :class="titleClass"
      >
        {{ title }}
      </NText>

      <NText variant="caption1" tag="p" class="pb-6 px-2" :class="bodyClass">
        {{ body }}
      </NText>

      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
type EmptyListPropsType = {
  title: string;
  body?: string;
  bodyClass?: string | string[];
  wrapperClass?: string | string[];
  titleClass?: string | string[];
};

defineProps<EmptyListPropsType>();
</script>
